export default "/3b8813e802de6219f7d4c232a48ac926.png";